import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const MinimumSelectionErrorModal = ({ isOpen, toggle, message }) => {
  // Generate unique IDs for accessibility
  const modalId = 'min-selection-error-modal'
  const modalTitleId = 'min-selection-error-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="error.redemption.minSelectionTitle" />
        </h2>
        <p>
          <FormattedMessage
            id="error.redemption.minSelectionDescription"
            values={{ credits: message || 1 }}
          />
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button block outline color="danger" onClick={toggle} aria-label="Close this message">
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

MinimumSelectionErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

MinimumSelectionErrorModal.defaultProps = {
  message: 1,
}

export default MinimumSelectionErrorModal
